import React from 'react';
import { Modal } from 'react-bootstrap';

const PlayOrSkip = ({
    game_url = '#',
    skip_url = '#!',
    showModal = false,
    onGamePlayed,
    closeModal,
}) => {
    const modalStyles = {
        background: 'rgba(0, 0, 0, .4)',
        display: 'flex',
    };

    return (
        <div
            className={`modal ${showModal ? 'in' : ''} game-modal`}
            style={showModal ? modalStyles : { display: 'none' }}
        >
            <Modal.Dialog show={showModal.toString()}>
                <Modal.Header onClick={closeModal}>
                    <button
                        className="btn-close close"
                        aria-label="Close"
                        onClick={closeModal}
                    >
                        X
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className="center-block text-center"></div>
                    <div className="center-block text-center">
                        <p>
                            Click below to continue and play
                            <br /> the game
                        </p>
                        <a
                            className="theme-btn"
                            href={'#!'}
                            onClick={e => {
                                onGamePlayed(game_url);
                            }}
                        >
                            Play Game
                        </a>
                    </div>
                    <div className="center-block text-center">
                        <p>
                            Click below to skip the game and
                            <br /> enter more tickets.
                        </p>
                        <a
                            className="theme-btn"
                            href={skip_url}
                            onClick={closeModal}
                        >
                            Skip
                        </a>
                    </div>
                </Modal.Body>
            </Modal.Dialog>
        </div>
    );
};

export default PlayOrSkip;
